import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '../context/SessionContext.jsx';

/**
 * Client-side gate for admin routes. This is a convenience only — every
 * admin endpoint is independently guarded by requireAdmin on the server,
 * which is where the actual control lives. Hiding the nav item is not
 * security; the old app relied on exactly that and left the endpoints open.
 */
export default function RequireAdmin() {
  const { user, isLoading } = useSession();
  if (isLoading) return null;
  if (!user?.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
